















import { Component, Vue } from 'vue-property-decorator';
import MainLayout from '@/layouts/Main.vue';
import { Lang } from '@/lang/en/bookings.ts';

@Component({
  components: {
    MainLayout,
  },
})
export default class Terms extends Vue {
  private lang: object = Lang;
}
